export default function getImageLink(link: string, size: number) {
  return `https://lh3.googleusercontent.com/d/${link?.replace("https://drive.google.com/file/d/", "").replace("/view?usp=drive_link", "")}=s${size}?authuser=0`;
}